import React from "react"

export default function Home() {
  return <div>Lesson 0</div>
}
